export const EVENT_BUS_TARGET = 'confirm-email'
